import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { ReactComponent as LsLogoHorizontal } from '@lifesize/ux-assets/vectors/svgLogos/lsHorizontalTM.svg';
import Help from 'containers/Header/Help';
import SelectLocale from 'containers/SelectLocale/SelectLocaleContainer';
import _compact from 'lodash/compact';
import classes from './PageLayout.module.scss';

const messages = defineMessages({
  companyName: {
    id: 'companyName',
    defaultMessage: 'Lifesize'
  }
});

export const PageLayout = ({ children, intl, className }) => {
  const pageClassNames = _compact([className, classes.container]).join(' ');
  return (
    <div className={pageClassNames}>
      <div className={classes.header}>
        <div className={classes.lsLogoContainer}>
          <LsLogoHorizontal
            className={classes.lsLogo}
            data-testid="lsLogoHorizontal"
            alt={intl.formatMessage(messages.companyName)}
          />
        </div>
        <Help />
        <div className={classes.languageDropdown}>
          <SelectLocale buttonClass={classes.buttonClass} dropdownClass={classes.dropdownClass} />
        </div>
      </div>
      <div className={classes.body}>{children}</div>
      <div className={classes.footer}>
        <FormattedMessage
          id="components.getPlugin.footer"
          description="Footer marketing message"
          defaultMessage="Lifesize audio, web, and video conferencing... we’ve got your meetings covered. {url}"
          values={{
            url: <a href="http://www.lifesize.com">lifesize.com</a>
          }}
        />
      </div>
    </div>
  );
};

PageLayout.propTypes = {
  children: PT.element.isRequired,
  className: PT.string,
  intl: PT.object
};

export default injectIntl(PageLayout);
